import { useQuery } from '@tanstack/react-query'
import { api } from '..'

export type TSmsRecipient = {
  id: string
  phoneNumber: string
}

export const getSmsRecipients = (alertRuleId: string) =>
  api
    .get<TSmsRecipient[]>(`/v1/alert-rules/${alertRuleId}/sms-recipients`)
    .then(({ data }) => data)

export const useGetSmsRecipients = (alertRuleId?: string) => {
  if (!alertRuleId) throw new Error('Missing alertRuleId')

  return useQuery({
    queryKey: ['alertRule', alertRuleId, 'smsRecipients'],
    queryFn: () => getSmsRecipients(alertRuleId),
  })
}
